import { forwardRef, type SelectHTMLAttributes } from 'react'
import { ChevronDownIcon } from './icons'

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  invalid?: boolean
}

/**
 * Native `<select>` in a styled shell.
 *
 * Deliberately native: a custom listbox is a large amount of keyboard and screen-reader work to
 * get right, and on mobile the platform picker is better than anything rebuilt in a div.
 */
const Select = forwardRef<HTMLSelectElement, SelectProps>(function Select(
  { invalid = false, className = '', disabled, children, ...rest },
  ref,
) {
  const shell = [
    'input-shell',
    'select-shell',
    invalid ? 'input-shell--invalid' : '',
    disabled ? 'input-shell--disabled' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={shell}>
      <select
        ref={ref}
        className="input-shell__control"
        aria-invalid={invalid || undefined}
        disabled={disabled}
        {...rest}
      >
        {children}
      </select>
      <span className="select-shell__chevron">
        <ChevronDownIcon size={16} />
      </span>
    </div>
  )
})

export default Select
